import { createAppTheme } from "./theme.base";
import { devColors } from "./theme.dev.tokens";

export const DevLightThemeWithResponsiveFontSizes = createAppTheme(
  "light",
  devColors.light,
);

export const DevDarkThemeWithResponsiveFontSizes = createAppTheme(
  "dark",
  devColors.dark,
);
